/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styles from './index.module.scss';
import { OfferListing } from '~/common/models';
import { TooltipDisclaimer } from '~/common/components/ui-elements';
import { money } from '~/common/utils';
import { OfferSashContent } from './offerSashContent';
import { DeviceType } from '../offer-listing/offerDeviceType';
import { Button } from '@ui-elements';
import cn from 'classnames';
import { LegalDisclaimerContent } from './legalDisclaimerContent';

interface OfferMainTileCardProps {
  offer: OfferListing;
  hideContent?: boolean;
  deviceType: DeviceType;
}

export const OfferMainCard = ({
  offer,
  hideContent,
  deviceType,
}: OfferMainTileCardProps) => {
  const offerUrl = `/special-offers/${offer.uniqueName}`;
  const hasPrice = offer.price > 0;
  const mediaForDevice =
    offer.media?.find((m) => m.devices.includes(deviceType)) ||
    offer.media?.[0];
  const mediaThumbnail = offer.media?.find((m) => m.isThumbnail === true);

  return (
    <div
      className={cn(styles.mainTileCard, {
        [styles.hoverable]: hideContent,
      })}
      onClick={() => window.open(offerUrl, '_self')}
    >
      <div
        className={cn(styles.imageWrapper, {
          [styles.roundedImage]: hideContent && deviceType !== 'mobile',
        })}
      >
        <img src={mediaForDevice?.url || ''} alt={offer.title} />
        <OfferSashContent sash={offer.sash} />
        <LegalDisclaimerContent
          disclaimer={mediaThumbnail}
          deviceType={deviceType}
        />
      </div>
      {!hideContent && (
        <div
          className={styles.mainTileContent}
          style={{
            color: `${offer.contentColor?.contentTextColor}` || 'inherit',
            background: offer.contentColor?.contentBackgroundColor || 'inherit',
          }}
        >
          <div className={styles.offerTitle}>
            <div
              className={styles.offerTitleText}
              dangerouslySetInnerHTML={{ __html: offer.title as string }}
            />
            {offer.titleDisclaimer && (
              <TooltipDisclaimer
                customContent
                disclaimer={offer.titleDisclaimer}
                triggerClassName={styles.disclaimerTrigger}
              />
            )}
          </div>

          {offer.blurb && (
            <div dangerouslySetInnerHTML={{ __html: offer.blurb }} />
          )}
          {offer.contentCta && deviceType !== 'mobile' && (
            <Button className={styles.ctaButton} href={offer.contentCta.link}>
              {offer.contentCta.text}
              {hasPrice && (
                <span>
                  <sup>$</sup>
                  <span>{money(offer.price).replace('$', '')}</span>
                  <sup>*</sup>
                </span>
              )}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
